import React from 'react';
import { Header } from './header';
import { Footer } from './footer';
import './weddingwebsite.css';
import { WeddingWebsiteSEO } from './SEO';

const portfolioItems = [
    {
        id: 1,
        title: "Senthil Dharanika",
        category: "Luxury",
        description: "A timeless rose-themed wedding website with RSVP, gallery & countdown timer.",
        link: "https://wedding.frameophotography.in/",
        badge: "Featured",
        img: require("../assets/images/sendhil-dharanika.jpg"),
        features: ["RSVP Form", "Photo Gallery", "Countdown Timer"],
    },
    {
        id: 2,
        title: "Jebaraj Juanitha",
        category: "Premium",
        description: "A timeless rose-themed wedding website with Live",
        link: "https://frameophotography.in/",
        badge: "Popular",
        img: require("../assets/images/frameo-photography.jpg"),
        features: ["Live Streaming", "Story Timeline", "Guest List"],
    },
    {
        id: 3,
        title: "Ranjith Pooja",
        category: "Classic",
        description: "A vibrant floral design with pastel tones, gift registry & event schedule.",
        link: "https://ranjithpooja.frameophotography.in/",
        badge: "New",
        img: require("../assets/images/ranjith-poja-amy.jpg"),
        features: ["Gift Registry", "Event Schedule", "Map Integration"],
    },
    // {
    //     id: 4,
    //     title: "Royal Mandap",
    //     category: "Traditional",
    //     description: "South Indian traditional style wedding site with mehendi & sangeet events.",
    //     link: "https://amytechnologies.in/wedding-demo/royal-mandap",
    //     badge: "Traditional",
    //     img: require("../assets/images/product/04.jpg"),
    //     features: ["Multi-Event", "RSVP", "Photo Gallery"],
    // },
    // {
    //     id: 5,
    //     title: "Beach Sunset",
    //     category: "Destination",
    //     description: "A dreamy beach-themed site with travel guide, accommodation and map.",
    //     link: "https://amytechnologies.in/wedding-demo/beach-sunset",
    //     badge: "Trending",
    //     img: require("../assets/images/product/05.jpg"),
    //     features: ["Travel Guide", "Hotel Booking", "Countdown"],
    // },
    // {
    //     id: 6,
    //     title: "Minimal Chic",
    //     category: "Modern",
    //     description: "A clean, modern minimalist website with seamless mobile experience.",
    //     link: "https://amytechnologies.in/wedding-demo/minimal-chic",
    //     badge: "Modern",
    //     img: require("../assets/images/product/06.jpg"),
    //     features: ["Mobile First", "RSVP", "Story Timeline"],
    // },
    // {
    //     id: 7,
    //     title: "Garden Romance",
    //     category: "Classic",
    //     description: "Garden-inspired wedding site with soft greens, florals and guest messaging.",
    //     link: "https://amytechnologies.in/wedding-demo/garden-romance",
    //     badge: "Popular",
    //     img: require("../assets/images/product/07.jpg"),
    //     features: ["Guest Messaging", "Gallery", "Countdown"],
    // },
    // {
    //     id: 8,
    //     title: "Starry Night",
    //     category: "Luxury",
    //     description: "Dark elegant theme with gold accents, perfect for evening/night receptions.",
    //     link: "https://amytechnologies.in/wedding-demo/starry-night",
    //     badge: "Featured",
    //     img: require("../assets/images/product/08.jpg"),
    //     features: ["Gift Registry", "Event Timeline", "RSVP"],
    // },
];

const features = [
    { icon: "fas fa-mobile-alt", title: "Mobile Responsive", desc: "Beautifully optimized for all screen sizes including phones & tablets." },
    { icon: "fas fa-images", title: "Photo Galleries", desc: "Showcase your love story with unlimited photo album uploads." },
    // { icon: "fas fa-envelope-open-text", title: "RSVP Management", desc: "Easily collect and manage guest RSVPs with a smart dashboard." },
    { icon: "fas fa-clock", title: "Countdown Timer", desc: "Build excitement with a live countdown to your big day." },
    { icon: "fas fa-map-marker-alt", title: "Venue Map", desc: "Embed interactive Google Maps to guide your guests perfectly." },
    // { icon: "fas fa-palette", title: "Custom Themes", desc: "Choose from 50+ stunning themes tailored to your love story." },
];


export const WeddingWebsite = () => {
    return (
        <>
            <WeddingWebsiteSEO />
            <Header />

            {/* ─── Hero Banner ─────────────────────────────── */}
            <section
                className="ww-hero"
                style={{ background: "url(" + require("../assets/images/slider/single-banner.jpg") + ") no-repeat center/cover" }}
            >
                <div className="ww-hero-overlay">
                    <div className="container">
                        <div className="ww-hero-content">
                            <span className="ww-hero-badge">✨ Premium Wedding Websites</span>
                            <h1 className="ww-hero-title">Your Love Story <br /> Deserves a Beautiful Website</h1>
                            <p className="ww-hero-sub">Handcrafted wedding websites by <strong>AMY Technologies</strong> — elegant, modern &amp; fully personalised.</p>
                            <div className="ww-hero-btns">
                                <a href="https://wa.me/917339446882?text=Hi%20AMY%20Technologies%2C%20I%20am%20interested%20in%20getting%20a%20wedding%20website.%20Please%20share%20more%20details." target='_blank' className="ww-btn-outline">Get Started Free</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ─── Features Strip ───────────────────────────── */}
            <section className="ww-features-section">
                <div className="container">
                    <div className="ww-section-header">
                        <span className="ww-section-tag">What We Offer</span>
                        <h2 className="ww-section-title">Everything You Need for Your Perfect Day</h2>
                    </div>
                    <div className="ww-features-grid">
                        {features.map((f, i) => (
                            <div className="ww-feature-card" key={i}>
                                <div className="ww-feature-icon"><i className={f.icon}></i></div>
                                <h5>{f.title}</h5>
                                <p>{f.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ─── Portfolio Section ────────────────────────── */}
            <section className="ww-portfolio-section" id="portfolio">
                <div className="container">
                    <div className="ww-section-header">
                        <span className="ww-section-tag">Our Portfolio</span>
                        <h2 className="ww-section-title">Stunning Wedding Website Designs</h2>
                        <p className="ww-section-sub">Click any design to preview a live demo of the wedding website.</p>
                    </div>
                    <div className="ww-portfolio-grid">
                        {portfolioItems.map((item) => (
                            <div className="ww-portfolio-card" key={item.id}>
                                <div className="ww-portfolio-img-wrap">
                                    <img src={item.img} alt={item.title} className="ww-portfolio-img" />
                                    <span className={`ww-portfolio-badge badge-${item.badge.toLowerCase()}`}>{item.badge}</span>
                                    <div className="ww-portfolio-overlay">
                                        <a href={item.link} target="_blank" rel="noreferrer" className="ww-preview-btn">
                                            <i className="fas fa-external-link-alt"></i> Live Preview
                                        </a>
                                    </div>
                                </div>
                                <div className="ww-portfolio-info">
                                    <span className="ww-portfolio-category">{item.category}</span>
                                    <h5 className="ww-portfolio-title">{item.title}</h5>
                                    <p className="ww-portfolio-desc">{item.description}</p>
                                    <div className="ww-portfolio-features">
                                        {item.features.map((feat, idx) => (
                                            <span className="ww-feat-tag" key={idx}>
                                                <i className="fas fa-check-circle"></i> {feat}
                                            </span>
                                        ))}
                                    </div>
                                    <a href={item.link} target="_blank" rel="noreferrer" className="ww-card-link">
                                        View Demo <i className="fas fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ─── Why AMY Technologies ─────────────────────── */}
            <section className="ww-why-section">
                <div className="container">
                    <div className="ww-why-inner">
                        <div className="ww-why-text">
                            <span className="ww-section-tag light">Why Choose Us</span>
                            <h2 className="ww-why-title">Crafted by AMY Technologies</h2>
                            <p>AMY Technologies is a trusted digital agency specializing in wedding websites, mobile apps & business software. With 5+ years of experience and 200+ happy couples, we bring your dream wedding website to life.</p>
                            <ul className="ww-why-list">
                                <li><i className="fas fa-check-circle"></i> 100% Custom Designs – No templates, truly yours</li>
                                <li><i className="fas fa-check-circle"></i> Delivered in 3–5 business days</li>
                                <li><i className="fas fa-check-circle"></i> Free lifetime hosting included</li>
                                <li><i className="fas fa-check-circle"></i> WhatsApp &amp; call support 7 days a week</li>
                                <li><i className="fas fa-check-circle"></i> 50+ premium themes to choose from</li>
                            </ul>
                            <a href="https://wa.me/917339446882?text=Hi%20AMY%20Technologies%2C%20I%20am%20interested%20in%20getting%20a%20wedding%20website.%20Please%20share%20more%20details." target="_blank" rel="noreferrer" className="ww-btn-primary mt-3">
                                <i className="fab fa-whatsapp"></i> Get a Free Quote
                            </a>
                        </div>
                        <div className="ww-why-stats">
                            <div className="ww-stat-card"><span className="ww-stat-num">200+</span><span className="ww-stat-label">Happy Couples</span></div>
                            <div className="ww-stat-card"><span className="ww-stat-num">50+</span><span className="ww-stat-label">Unique Themes</span></div>
                            <div className="ww-stat-card"><span className="ww-stat-num">5+</span><span className="ww-stat-label">Years Experience</span></div>
                            <div className="ww-stat-card"><span className="ww-stat-num">24/7</span><span className="ww-stat-label">Customer Support</span></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ─── Contact / Get Started ────────────────────── */}
            <section className="ww-contact-section" id="contact">
                <div className="container">
                    <div className="ww-section-header">
                        <span className="ww-section-tag">Contact Amy Technologies</span>
                        <h2 className="ww-section-title">Ready to Build Your Wedding Website?</h2>
                        <p className="ww-section-sub">Reach out to us — we'll get back to you within 24 hours.</p>
                    </div>
                    <div className="ww-contact-grid">
                        {/* Info cards */}
                        <div className="ww-contact-info">
                            {/* Register Office */}
                            <div className="ww-info-card">
                                <div className="ww-info-icon"><i className="fas fa-map-marker-alt"></i></div>
                                <div>
                                    <h5>Register Office</h5>
                                    <p>No 17/1, S R Complex, Karattur Road,<br />
                                       Sathyamangalam, Opp SBI Bank,<br />
                                       Erode – 638 402, Tamil Nadu.</p>
                                </div>
                            </div>
                            {/* Corporate Office */}
                            <div className="ww-info-card">
                                <div className="ww-info-icon"><i className="fas fa-building"></i></div>
                                <div>
                                    <h5>Corporate Office</h5>
                                    <p>9/321 D, Vijayamahal Garden,<br />
                                       Near Toll Gate, Ragavendrapuram,<br />
                                       Mettupatti, Vazhapadi, Salem – 636 111, Tamil Nadu.</p>
                                </div>
                            </div>
                            {/* Phone */}
                            <div className="ww-info-card active">
                                <div className="ww-info-icon"><i className="fas fa-phone-alt"></i></div>
                                <div>
                                    <h5>WhatsApp &amp; Office</h5>
                                    <p>
                                        <a href="https://wa.me/917339446882" target="_blank" rel="noreferrer">
                                            <i className="fab fa-whatsapp" style={{marginRight:'6px', color:'#25d366'}}></i>+91 73394 46882 (WhatsApp)
                                        </a><br />
                                        <a href="tel:+919942213232">
                                            <i className="fas fa-phone" style={{marginRight:'6px'}}></i>+91 99422 13232 (Office)
                                        </a>
                                    </p>
                                </div>
                            </div>
                            {/* Email */}
                            <div className="ww-info-card">
                                <div className="ww-info-icon"><i className="fas fa-envelope"></i></div>
                                <div>
                                    <h5>Email Us</h5>
                                    <p>
                                        <a href="mailto:amytechnologies2024@gmail.com">amytechnologies2024@gmail.com</a>
                                    </p>
                                </div>
                            </div>
                            {/* Social Links */}
                            <div className="ww-social-row">
                                <a href="https://www.facebook.com/profile.php?id=61560587132528&mibextid=ZbWKwL" target="_blank" rel="noreferrer" className="ww-social-btn fb" title="Facebook"><i className="fab fa-facebook-f"></i></a>
                                <a href="https://www.instagram.com/amy_technologies" target="_blank" rel="noreferrer" className="ww-social-btn ig" title="Instagram"><i className="fab fa-instagram"></i></a>
                                <a href="https://wa.me/917339446882" target="_blank" rel="noreferrer" className="ww-social-btn wa" title="WhatsApp"><i className="fab fa-whatsapp"></i></a>
                                <a href="https://www.youtube.com/@amy_technologies" target="_blank" rel="noreferrer" className="ww-social-btn yt" title="YouTube"><i className="fab fa-youtube"></i></a>
                                <a href="https://x.com/amytech2024" target="_blank" rel="noreferrer" className="ww-social-btn tw" title="X / Twitter"><i className="fab fa-twitter"></i></a>
                                <a href="https://www.linkedin.com/company/amytechnologies/?viewAsMember=true" target="_blank" rel="noreferrer" className="ww-social-btn li" title="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>

                        {/* Google Map */}
                        <div className="ww-contact-map-wrap">
                            {/* <iframe
                                title="AMY Technologies – Corporate Office, Vazhapadi"
                                src="https://maps.google.com/maps?q=9%2F321+D+Vijayamahal+Garden+Near+Toll+Gate+Ragavendrapuram+Mettupatti+Vazhapadi+Salem+636111&output=embed"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe> */}
                            <iframe title="AMY Technologies – Corporate Office, Vazhapadi" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3907.4908551765116!2d78.3339434!3d11.659584299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bab8d743f0ab663%3A0xb3425b23bb8d87a0!2sAmy%20technologies%20Corporate%20office!5e0!3m2!1sen!2sin!4v1778222686295!5m2!1sen!2sin" width="600" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            <div className="ww-map-links">
                                <a href="https://share.google/lmrh1W56anYXmhzxT" target="_blank" rel="noreferrer" className="ww-map-open-btn">
                                    <i className="fas fa-external-link-alt"></i> Open in Google Maps
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};
